module.exports = __webpack_public_path__ + "static/img/ask1-bg.67d5f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/ask1-bg.png
// module id = j2su
// module chunks = 0